import { all } from 'redux-saga/effects';

import ibgeSaga from './ibge/combineSaga';
import municipioSaga from './municipio/combineSaga';

export default all([ibgeSaga, municipioSaga]);
